/* @flow */

import getConfig from 'next/config';

import * as React from 'react';
import { getUrlParam } from '../utils/urlUtils';

const {
  publicRuntimeConfig: {
    searchReferrers: BLOCKED_REFERERS,
  },
} = getConfig();

export type Props = {};

export default
class ReferralDataSetter extends React.PureComponent<Props> {
  componentDidMount() {
    if (typeof window !== 'undefined') {
      const ref = getUrlParam('ref');
      const ts = getUrlParam('ts');
      if (ref) {
        const refPartten = /^\d+$/;
        if (refPartten.test(ref)) {
          window.sessionStorage &&
            window.sessionStorage.setItem('refId', ref);
        }
      }
      if (ts) {
        const tsPattern = /^[\w|\d|\.|-]+$/; // eslint-disable-line
        if (tsPattern.test(ts)) {
          window.sessionStorage &&
            window.sessionStorage.setItem('ts', ts.substr(0, 16));
        }
      }
      const referer = document.referrer;
      const gclid = getUrlParam('gclid');
      if (BLOCKED_REFERERS.some(blocked => referer.includes(blocked)) ||
          gclid !== null) {
        window.sessionStorage &&
          window.sessionStorage.setItem('ad_block', true);
        console.warn('Referred by search engine, blocking referrer code.');
      }
    }
  }

  render() {
    return null;
  }
}
